import * as React from 'react';

import { Button } from '@ReactComponents/Button/Button';
import { Icon } from '@ReactComponents/Icon';
import { ManualUploadCardProgramPanelKeys } from '@ReactComponents/ManualUploadCardProgramModal';
import { ModalBody } from '@ReactComponents/ModalBody';
import { ModalFooter } from '@ReactComponents/ModalFooter';
import { IWizardPanelProps, WizardPanel } from '@ReactComponents/Wizard/Wizard';

// Services
import { ManualUploadCardProgramApi } from '@ClientApi/manualUploadCardProgram';
import { ILinkedAccountModel } from '@Shared/models';

// Styles
import * as style from './ManualUploadCardProgramCreate.styl';

interface IManualUploadCardProgramCreateProps {
  userId?: string;
  onReceiveProgram: (cardProgram: ILinkedAccountModel) => void;
}

interface IManualUploadCardProgramCreateState {
  programName: string;
}

export class ManualUploadCardProgramCreate extends WizardPanel<
  ManualUploadCardProgramPanelKeys,
  IManualUploadCardProgramCreateProps,
  IManualUploadCardProgramCreateState
> {
  constructor(props: IWizardPanelProps<ManualUploadCardProgramPanelKeys> & IManualUploadCardProgramCreateProps) {
    super(props);

    this.state = {
      programName: ''
    };
  }

  onSkipAndCreate() {
    ManualUploadCardProgramApi.create(this.state.programName, false);
  }

  async onCreateAndUpload() {
    const program = await ManualUploadCardProgramApi.create(this.state.programName, true);
    this.props.onReceiveProgram(program);
    this.props.changePanel('start');
  }

  render() {
    const buttonsDisabled = !this.state.programName;

    return (
      <div className={style.global}>
        <ModalBody>
          <label>Program Name</label>
          <input
            placeholder="Card Program Name"
            value={this.state.programName}
            onChange={(e) => this.setState({ programName: e.currentTarget.value })}
          />
          <div className="info">
            <p>
              A <strong>Statement Upload Program</strong> is recommended for users who frequently experience card connection issues. This is
              also an available option for card programs that aren't currently supported by {window.whitelabelConfiguration.tags.brandName}.
            </p>
            <ul>
              <li>Only program admins can upload transactions to this program.</li>
              <li>Admins are responsible for uploading transactions accurately, and maintaining a complete list.</li>
              <li>
                We highly recommend reading our{' '}
                <a target="_blank" rel="noopener noreferrer" href={window.whitelabelConfiguration.supportLinks.manualStatementUpload}>
                  best practices documentation{' '}
                </a>
                if you choose to use a statement upload program.
              </li>
            </ul>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button disabled={buttonsDisabled} onClick={() => this.onSkipAndCreate()}>
            Skip and Create
          </Button>
          <Button disabled={buttonsDisabled} primary onClick={() => this.onCreateAndUpload()}>
            Upload Transactions
            <Icon small name="right-arrow-small" />
          </Button>
        </ModalFooter>
      </div>
    );
  }
}
